export const Swieta = [
  {
    id: 'swieto-1',
    name: 'Karp po żydowsku',
    category: 'SWIĘTA',
    shortDesc: 'Tradycyjny karp po żydowsku w sosie cebulowym.',
    fullDesc: 'Karp po żydowsku to klasyczne danie na wigilijnym stole, przygotowane z karpia duszonego w aromatycznym sosie cebulowym.',
    image: 'swieta.jpg',
    imageCredit: 'Davor Nisevic',
    preparation: 'Pokrój karpia na dzwonka, obtocz w mące i usmaż. Cebulę podsmaż i dodaj do ryby z przyprawami. Gotuj przez 30 minut.',
    ingredients: [
      '1 karp (ok. 1 kg)',
      '2 cebule',
      '2 łyżki mąki',
      'Sól, pieprz do smaku',
      '1 łyżka cukru',
      'Oliwa do smażenia'
    ].join('\n'),
    path: 'swieta'
  },
  {
    id: 'swieto-2',
    name: 'Pierogi z kapustą i grzybami',
    category: 'SWIĘTA',
    shortDesc: 'Tradycyjne pierogi z kapustą kiszoną i grzybami.',
    fullDesc: 'Pierogi z kapustą i grzybami to nieodłączny element wigilijnego menu, pełne smaku i aromatu.',
    image: 'swieta.jpg',
    imageCredit: 'Davor Nisevic',
    preparation: 'Przygotuj ciasto, a następnie nadziej je mieszanką kapusty i grzybów. Gotuj pierogi przez 5 minut od momentu wypłynięcia.',
    ingredients: [
      '500g mąki pszennej',
      '200g kapusty kiszonej',
      '100g grzybów leśnych',
      '1 cebula',
      'Sól, pieprz do smaku',
      'Woda do ciasta'
    ].join('\n'),
    path: 'swieta'
  },
  {
    id: 'swieto-3',
    name: 'Kutia',
    category: 'SWIĘTA',
    shortDesc: 'Tradycyjna kutia z pszenicą, makiem i miodem.',
    fullDesc: 'Kutia to słodkie danie wigilijne, przygotowane z pszenicy, maku, orzechów, miodu i bakalii.',
    image: 'swieta.jpg',
    imageCredit: 'Davor Nisevic',
    preparation: 'Ugotuj pszenicę, a następnie wymieszaj ją z makiem, miodem, orzechami i bakaliami. Odstaw na kilka godzin.',
    ingredients: [
      '200g pszenicy',
      '100g maku',
      '50g orzechów włoskich',
      '50g rodzynek',
      '2 łyżki miodu',
      '1 łyżka cukru'
    ].join('\n'),
    path: 'swieta'
  },
]

export default Swieta;
